import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { uniqueId } from 'lodash';

const SelectField = ({
  options = [],
  isReadOnly,
  value,
  onChange
}) => {
  const key = uniqueId('select');

  const handleValueChange = (newValue) => {
    if (onChange) {
      // Simular el evento como en el componente original
      onChange({ target: { value: newValue } });
    }
  };

  return (
    <Select
      disabled={isReadOnly}
      onValueChange={handleValueChange}
      value={value || ''}
    >
      <SelectTrigger>
        <SelectValue placeholder="Selecciona una opción" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value=" "> </SelectItem>
        {options.map((opt, index) => {
          if (typeof opt === 'string') {
            return <SelectItem key={`${key}-${index}`} value={opt}>{opt}</SelectItem>;
          }
          return <SelectItem key={`${key}-${index}`} value={opt.value}>{opt.text}</SelectItem>;
        })}
      </SelectContent>
    </Select>
  );
};

export default SelectField;
